import { render, staticRenderFns } from "./CampaignBanner.vue?vue&type=template&id=4b012654&scoped=true&"
import script from "./CampaignBanner.vue?vue&type=script&lang=js&"
export * from "./CampaignBanner.vue?vue&type=script&lang=js&"
import style0 from "./CampaignBanner.vue?vue&type=style&index=0&id=4b012654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b012654",
  null
  
)

export default component.exports